export const DISCOUNT_TYPE = {
  PERCENTAGE: 'percentage',
  AMOUNT: 'amount'
}
